(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function initializeColorVariantCards(root = document) {
    const cards = [];

    if (root instanceof Element && root.matches('[data-color-variant-card]')) {
      cards.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-color-variant-card]').forEach((card) => {
        cards.push(card);
      });
    }

    cards.forEach((card) => {
      if (card.dataset.colorCardInitialized === 'true') {
        return;
      }

      const productCard = card.querySelector('product-card');

      if (!productCard) {
        return;
      }

      const variantId = card.dataset.colorVariantId;
      const mediaId = card.dataset.colorMediaId;
      const featuredMediaUrl = card.dataset.colorFeaturedMediaUrl;

      if (!variantId) {
        return;
      }

      /*
       * Make the whole card, title and image link
       * directly to this color variant.
       */
      if (typeof productCard.applyVariantToLinks === 'function') {
        productCard.applyVariantToLinks(variantId);
      } else {
        card
          .querySelectorAll(
            '.product-card__link, [ref="productTitleLink"], [ref="cardGalleryLink"]'
          )
          .forEach((link) => {
            if (!link.href) {
              return;
            }

            const productUrl = new URL(link.href, window.location.origin);
            productUrl.searchParams.set('variant', variantId);
            link.href = productUrl.toString();
          });
      }

      /*
       * Correct image for product-page image transitions.
       */
      if (featuredMediaUrl) {
        productCard.setAttribute(
          'data-featured-media-url',
          featuredMediaUrl
        );
      }

      /*
       * Select the hidden color swatch that belongs
       * to this duplicated color card.
       *
       * We keep the swatch in the HTML but hide it visually.
       * This allows Horizon's own image reset/hover logic to
       * remember which color belongs to this card.
       */
      const swatchInput = card.querySelector(
        `swatches-variant-picker-component input[data-variant-id="${variantId}"]`
      );

      if (swatchInput) {
        swatchInput.checked = true;
      }

      /*
       * Show only the variant image belonging
       * to this card's color.
       */
      if (mediaId) {
        const variantSlides = card.querySelectorAll(
          'slideshow-slide[variant-image]'
        );

        variantSlides.forEach((slide) => {
          slide.hidden = slide.getAttribute('slide-id') !== mediaId;
        });

        if (typeof productCard.previewVariant === 'function') {
          productCard.previewVariant(mediaId);
        }
      }

      /*
       * If this product doesn't have a rendered swatch picker,
       * disable Horizon's image-reset hover behavior on this card
       * so it cannot jump back to another color.
       */
      if (!swatchInput) {
        const gallery = card.querySelector('[ref="cardGallery"]');

        if (gallery) {
          gallery.removeAttribute('on:pointerenter');
          gallery.removeAttribute('on:pointerleave');
        }
      }

      card.dataset.colorCardInitialized = 'true';
    });
  }

  function startColorVariantCards() {
    const initialize = () => {
      initializeColorVariantCards(document);

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) {
              initializeColorVariantCards(node);
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };

    if (customElements.get('product-card')) {
      initialize();
    } else {
      customElements.whenDefined('product-card').then(initialize);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startColorVariantCards,
      { once: true }
    );
  } else {
    startColorVariantCards();
  }

  } catch(e) { console.error(e); }
})();
})();
